import awsmobile from '../aws-exports';

// localStorage-avaimet sovelluskohtaisella prefiksillä: dev-ympäristössä Hubblen sovellukset jakavat
// originin (localhost:9090) ja siten localStoragen.
const PREFIX = 'alituspalvelu.';
const LEGACY_KEYS = ['auth_type', 'session', 'userInfo', 'tenant'];

export function appKey(key) {
  return PREFIX + key;
}

// Kertaluonteinen siirto prefiksittömistä avaimista, jottei käyttäjiä kirjata ulos käyttöönoton jälkeen.
// Siirretään vain tämän sovelluksen Cognito-istunto (tokenin aud), koska dev-originilla avaimet voivat
// olla toisen sovelluksen.
function migrateLegacySession() {
  if (localStorage.getItem(appKey('auth_type')) !== null || localStorage.getItem('auth_type') !== 'cognito') {
    return;
  }
  try {
    const idToken = JSON.parse(localStorage.getItem('session')).idToken;
    const claims = JSON.parse(atob(idToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (claims.aud !== awsmobile.aws_user_pools_web_client_id) {
      return;
    }
  } catch (e) {
    return;
  }
  LEGACY_KEYS.forEach(key => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      localStorage.setItem(appKey(key), value);
    }
  });
}

// Ajetaan importissa, ennen kuin user.service ja tenant.service lukevat istunnon.
migrateLegacySession();
